import { Component } from "@angular/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

@Component({
  template: `
    <h2 mat-dialog-title>Enter Email Addresses</h2>
    <div mat-dialog-content>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Emails</mat-label>
        <input matInput [formControl]="emailControl" placeholder="Enter email addresses (comma separated)">
        @if (emailControl.hasError('required')) {
          <mat-error>Email is required</mat-error>
        }
        @if (emailControl.hasError('invalidEmails')) {
          <mat-error>One or more email addresses are invalid</mat-error>
        }
        <mat-hint>Separate multiple email addresses with commas</mat-hint>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button color="primary" [disabled]="!emailControl.valid" (click)="onSubmit()">Send</button>
    </div>
  `,
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
  ],
})
export class CsvEmailDialogComponent {
  emailControl = new FormControl("", [Validators.required, this.validateEmails]);

  constructor(private dialogRef: MatDialogRef<CsvEmailDialogComponent>) {}

  validateEmails(control: FormControl): { [key: string]: any } | null {
    const emails = control.value.split(",").map((e: string) => e.trim());
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emails.every((email: string) => emailRegex.test(email));
    return valid ? null : { invalidEmails: true };
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.emailControl.valid && this.emailControl.value !== null) {
      const emails = this.emailControl.value.split(",").map((e: string) => e.trim());
      this.dialogRef.close(emails);
    }
  }
}
